import { Component, OnInit, Input, Inject, ChangeDetectionStrategy, AfterViewInit } from '@angular/core';

import { Controllers } from '@shared/core/controllers';
import * as Tokens from '@shared/core/tokens';
import * as Services from '@shared/core/services';

import { Observable } from 'rxjs';
import { startWith, delay } from 'rxjs/operators';

@Component({
    selector: 'shared-loyalty-for-member-rewards',
    templateUrl: './loyalty-for-member-rewards.shared.component.html',
    styleUrls: ['./loyalty-for-member-rewards.shared.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoyaltyForMemberRewardsComponent implements OnInit, AfterViewInit {
    @Input() public limit: number = null;
    @Input() public noRewardsButton: string = 'Order now';
    @Input() public noRewardsText: string = null;
    @Input() public noRewardsTitle: string = 'Looks like you don’t have any Rewards yet!';

    public rewards$: Observable<APICommon.IMemberFreeProductModel[]>;
    public loading$: Observable<boolean>;
    public showNoRewardsInfo$: Observable<boolean>;

    constructor(
        @Inject(Tokens.CONFIG_TOKEN) public config: IConfig,
        public controllers: Controllers,
        public routeService: Services.RouteService,
    ) {
    }

    ngOnInit(): void {
        this.rewards$ = this.controllers.loyalty.getRewardsForMember$()
            .pipe(
                startWith(null),
                delay(0),
            );

        this.loading$ = this.controllers.loyalty.isLoadingLoyaltyInfoForMember$();

        this.showNoRewardsInfo$ = this.controllers.loyalty.showNoRewardsInfo$();

        if (!this.noRewardsText) {
            if (this.config.appMode === IAppMode.LOYALTY_ONLY) {
                this.noRewardsText = 'Remember to scan your card or provide your mobile number every visit to start earning!';
                this.noRewardsButton = null;
            } else {
                this.noRewardsText = 'Place an order to start earning rewards ';
            }
        }
    }

    ngAfterViewInit(): void {
    }

    public handleOrderNowClick($event: Event): Promise<boolean> {
        return this.routeService.handleOrderMoreNavigation();
    }
}
